const RUN_EVERY = 5;
const ROLL_HISTORY_SIZE = 100;

module.exports = {
  RUN_EVERY,
  ROLL_HISTORY_SIZE,
};
